import React, { useState } from "react";
import { Plus } from "lucide-react";
import { FAQ } from "@/content";
import Reveal from "@/components/Reveal";

export default function Faq() {
  const [abierta, setAbierta] = useState(0);

  return (
    <section
      className="py-16 md:py-24"
      style={{ background: "var(--blanco)" }}
      data-testid="section-faq"
    >
      <div className="container-page">
        <Reveal className="text-center">
          <h2 className="h2-display" style={{ color: "var(--vino)" }}>
            Preguntas{" "}
            <span style={{ color: "var(--lima)" }}>frecuentes</span>
          </h2>
        </Reveal>

        <div className="mt-10 mx-auto" style={{ maxWidth: 740 }}>
          {FAQ.items.map((item, i) => {
            const open = abierta === i;
            return (
              <Reveal
                key={item.q}
                delay={Math.min(i, 4) * 80}
                className="mb-3"
              >
                <div
                  style={{
                    background: open ? "var(--lima-soft)" : "var(--crema)",
                    border: open
                      ? "2px solid var(--lima)"
                      : "2px solid rgba(107,31,58,0.07)",
                    borderRadius: 16,
                    overflow: "hidden",
                    transition: "background 250ms ease, border-color 250ms ease",
                  }}
                >
                  <button
                    type="button"
                    onClick={() => setAbierta(open ? -1 : i)}
                    aria-expanded={open}
                    data-testid={`faq-${i}`}
                    className="w-full flex items-center gap-3 text-left px-5 py-4"
                    style={{ background: "transparent", border: "none", cursor: "pointer" }}
                  >
                    <span
                      className="font-display grow"
                      style={{ fontSize: 17, color: "var(--vino)", lineHeight: 1.25 }}
                    >
                      {item.q}
                    </span>
                    <span
                      className="flex items-center justify-center rounded-full shrink-0"
                      style={{
                        width: 30,
                        height: 30,
                        background: open ? "var(--lima)" : "var(--blanco)",
                        transform: open ? "rotate(45deg)" : "rotate(0deg)",
                        transition: "transform 280ms ease, background 250ms ease",
                      }}
                      aria-hidden="true"
                    >
                      <Plus
                        size={17}
                        strokeWidth={3}
                        style={{ color: open ? "#fff" : "var(--vino)" }}
                      />
                    </span>
                  </button>
                  <div
                    className="overflow-hidden"
                    style={{
                      maxHeight: open ? 220 : 0,
                      opacity: open ? 1 : 0,
                      transition: "max-height 320ms ease, opacity 250ms ease",
                    }}
                  >
                    <p
                      className="px-5 pb-5 text-[16px] leading-relaxed"
                      style={{ color: "var(--carbon)" }}
                    >
                      {item.a}
                    </p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
